import React from "react";
import "../../index.css";

function FloatingSelectInput({ label, id, name, value, onChange, options, required, disabled = false }) {
	return (
		<div className="custom-floating-input select-wrapper active">
			<select id={id} name={name} className="form-select custom-floating-select" value={value} onChange={onChange} required={required} disabled={disabled}>
				{options.map((opt, idx) => (
					<option key={opt.value ?? idx} value={opt.value} disabled={opt.disabled || opt.value === ""}>
						{opt.label}
					</option>
				))}
			</select>
			<label htmlFor={id}>{label}</label>
		</div>
	);
}

export default FloatingSelectInput;
